// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UM_979ohvdkdE8a3JAxU,.R7Xbn0Sh7_cfLoKfaWs9{max-height:100%;padding-left:24px;padding-right:24px}.R7Xbn0Sh7_cfLoKfaWs9{padding-bottom:24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"presetList": `UM_979ohvdkdE8a3JAxU`,
	"presetUnifiedList": `R7Xbn0Sh7_cfLoKfaWs9`
};
export default ___CSS_LOADER_EXPORT___;
